(function () {
  'use strict';

  var activeTap = null;
  var MAX_TAP_DISTANCE = 12;

  function productLinkFromEvent(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest('a.nailhandy-card-media-link[href]');
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'touch' || event.button !== 0) return;
    var link = productLinkFromEvent(event);
    if (!link) return;

    activeTap = {
      pointerId: event.pointerId,
      link: link,
      x: event.clientX,
      y: event.clientY
    };
    link.classList.add('nailhandy-card-media-link--pressed');
  }, true);

  document.addEventListener('pointerup', function (event) {
    if (!activeTap || event.pointerId !== activeTap.pointerId) return;

    var tap = activeTap;
    activeTap = null;
    tap.link.classList.remove('nailhandy-card-media-link--pressed');

    var movedX = Math.abs(event.clientX - tap.x);
    var movedY = Math.abs(event.clientY - tap.y);
    if (movedX > MAX_TAP_DISTANCE || movedY > MAX_TAP_DISTANCE) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    tap.link.classList.add('nailhandy-card-media-link--navigating');
    window.location.assign(tap.link.href);
  }, true);

  function cancelTap(event) {
    if (!activeTap || (event.pointerId != null && event.pointerId !== activeTap.pointerId)) return;
    activeTap.link.classList.remove('nailhandy-card-media-link--pressed');
    activeTap = null;
  }

  document.addEventListener('pointercancel', cancelTap, true);
  window.addEventListener('blur', cancelTap);
})();
